<template>
  <el-dialog
    title="请输入图像验证码"
    :visible.sync="imageVisible"
    @close="imageVisibleClose"
    width="300px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div style="display: flex">
      <el-input
        v-model="sendverify.captcha"
        maxlength="4"
        placeholder="请输入验证码"
      ></el-input>
      <img
        style="margin-left: 15px"
        :src="`data:image/png;base64,${sendverify.captchaImg}`"
        alt=""
        @click="getCaptcha()"
      />
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button
        @click="(imageVisible = false), $set(sendverify, 'captcha', '')"
        >取 消</el-button
      >
      <el-button type="primary" @click="enter">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      imageVisible: false,
      sendverify: {
        captchaImg: "",
        captcha: "",
        uuid: "",
      },
    };
  },
  methods: {
    enter() {
      this.$emit("enter", this.sendverify);
      this.imageVisibleClose();
    },
    imageVisibleClose() {
      this.$emit("close");
    },
    // 获取图片验证码
    getCaptcha(val) {
      this.$api.manage.GetVierificationCode().then((res) => {
        if (res.code === 0 && res.data) {
          this.sendverify.captchaImg = res.data.img;
          this.sendverify.uuid = res.data.uuid;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
  watch: {
    visible(val) {
      this.imageVisible = val;
      if (val) {
        this.getCaptcha();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.box {
  padding: 25px;
  width: 100%;
  p {
    font-size: 16px;
    line-height: 38px;
  }
}
</style>